module.exports = __webpack_public_path__ + "img/simple2.568dc289.jpg";